import { combineReducers, createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { localizeReducer } from "react-localize-redux";
import { ReduxStoreModel, ReduxReducerModel } from '../redux/ReduxModel';
import { ExampleReducer } from '../redux/ExampleReducer';
import { MissionReducer } from '../redux/CheckpointReducer';
import { UserReducer } from '../redux/UserReducer';
import { ConstantReducer } from "src/redux/ConstantReducer";
import { ConfigReducer } from '../redux/ConfigReducer';

const rootReducer = combineReducers<ReduxStoreModel>({
    User: UserReducer,
    localize: localizeReducer, // Do not change this name. It must be 'localize'
    Mission: MissionReducer,
    Constants: ConstantReducer,
    Config: ConfigReducer,
    // The strange typecasting below is to ensure typechecking with the redux models
} as ReduxReducerModel as {});

const windowIfDefined = typeof window === 'undefined' ? null : window as any;
// If devTools is installed, connect to it
const devToolsExtension = windowIfDefined && windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__;
// devToolsExtension is either the function or null

// DEBUG
/**
 * This is the configured redux store. It includes all redux reducers and middleware, such as devtools
 */
const ConfiguredReduxStore = createStore(
    rootReducer,
    {} as any,
    compose(
      applyMiddleware(thunk),
      devToolsExtension != null ? devToolsExtension() : f => f
    )
  );
export default ConfiguredReduxStore;
// END DEBUG

/**
 * This is the configured redux store. It includes all redux reducers and middleware, such as devtools
 */
// let ConfiguredReduxStore = devToolsExtension == null ? createStore(rootReducer) : createStore(rootReducer, {}, devToolsExtension());
// export default ConfiguredReduxStore;



// WEBPACK FOOTER //
// ./src/core/ConfigureRedux.ts